import theme from './theme';

export default value => `${value * theme.scale}rem`;
